<template>
  <div style="background:#F9FBFD">
    <jz-header :currentPage="'home'"></jz-header>
    <div class="home-page">
      <div class="top-banner container">
        <img src="https://jzmall.lifejingzhi.com/file/jz-gw/home/home-banner.png"/>
        <!-- <div class="video-block">
          <div class="top-title">家政用鲸致·生活有品质</div>
          <div class="sub-title">互联网自营家政服务品牌</div>
          <img
            src="https://jzmall.lifejingzhi.com/file/jz-gw/play-btn.png"
            class="play-btn"
            @click="playVideo"
          />

        </div> -->
      </div>
      <!-- 专业家政 -->
      <div class="wrapper">
        <div class="zyjz container">
          <div class="zyjz-left">
            <div>专业家政</div>
            <div>服务到家</div>
            <img src="https://jzmall.lifejingzhi.com/file/jz-gw/icon-jy.png" />
          </div>
          <div class="zyjz-right">
            <div class="zyjz-item" @click="goService(0)">
              <div class="item-title">保洁</div>
            </div>
            <div class="zyjz-item" @click="goService(1)">
              <div class="item-title">家电清洗</div>
            </div>
            <div class="zyjz-item" @click="goService(4)">
              <div class="item-title">家居养护</div>
            </div>
            <div class="zyjz-item" @click="goService(3)">
              <div class="item-title">收纳</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 全面关注 -->
      <div class="service-category container">
        <div class="title">全面关注家庭服务领域</div>
        <div class="sub-title">居家保洁、深度清洁、家电蒸洗、搬家收纳，鲸致关注家庭服务的方方面面，致力提供品质家庭生活。</div>
        <div class="category-list">
          <div
            class="category-item"
            v-for="(item,index) in categoryList"
            :key="index"
            @mousemove="categoryHover(item)"
            @mouseout="categoryOut(item)"
            :id="item.cssId"
            data-toggle="modal"
            :data-target="'#'+item.cssId"
          >
            <img :src="item.url" />
            <div class="content-wrapper">
              <div class="title">{{item.title}}</div>
              <div class="name">{{item.name}}</div>
              <div class="detail">{{item.detail}}</div>
              <!-- @click="showDetail(index)"  -->
              <img
                :src="activeCategory==item.id?'https://jzmall.lifejingzhi.com/file/jz-gw/detail-btn-grey.png':'https://jzmall.lifejingzhi.com/file/jz-gw/detail-btn.png'"
                @click="showServiceNew(index)"
              />
            </div>
          </div>
        </div>
      </div>

      <div style="background:#fff;">
        <div class="container">
          <!-- 鲸致优势 -->
          <div class="jz-advantage">
            <div class="common-title">鲸致的优势</div>
            <div class="advantage-wrapper">
              <div class="advantage-left" ref="menu">
                <div
                  :class="['nav-item',activeCal==index?'active-card':'' ]"
                  v-for="(item,index) in cardList "
                  :key="index"
                  @click="navCarkClick(index)"
                >
                  <div>
                    <div class="card-title">{{item.title}}</div>
                    <div class="card-name">{{item.name}}</div>
                  </div>
                  <div class="card-number">{{item.id}}</div>
                </div>
              </div>
              <div class="advantage-right">
                <el-carousel
                  height="300px"
                  :autoplay="false"
                  indicator-position="outside"
                  type="card"
                  @change="carouselChange"
                  width="100%"
                  ref="carousel"
                  trigger="click"
                >
                  <el-carousel-item v-for="(item,index) in cardList " :key="index">
                    <div class="advantage-item">
                      <img :src="activeCal==index?item.url:item.subUrl" />
                    </div>
                  </el-carousel-item>
                </el-carousel>
                <div class="card-content">{{cardList[activeCal].content}}</div>
              </div>
            </div>
          </div>
          <!-- 服务流程 -->
          <div class="service-flow">
            <div class="title">标准化服务流程</div>
            <div class="sub-title">居家保洁、深度清洁、家电清洗、搬家收纳，鲸致关注家庭服务的方方面面，为提供品质家庭生活而努力。</div>
            <div class="flow-block">
              <div class="flow-left">
                <div class="step-one">3小时标准服务时长</div>
                <div class="step-two">服务全屋6区</div>
              </div>
              <div class="flow-right">
                <div class="step-three">坚持可视化服务</div>
                <div class="step-four">按区域、按顺序打扫</div>
              </div>
            </div>
            <img src="https://jzmall.lifejingzhi.com/file/jz-gw/jzsh-bz.png" />
          </div>
        </div>
      </div>

      <!-- 进口工具 -->
      <div class="tool-group container">
        <div class="tool-group-title">专业进口工具组</div>
        <div class="tool-list">
          <div class="tool-item">
            <img src="https://jzmall.lifejingzhi.com/file/jz-gw/tool-01.png" />
            <div class="tool-content">
              <div class="tool-title">清洁工具包</div>
              <div class="tool-line">· 专业工具组合</div>
              <div class="tool-line">· 专业清洁剂</div>
              <div class="tool-line">· 八色保洁布</div>
              <div class="tool-line">· 双桶清洁</div>
            </div>
          </div>
          <div class="tool-item">
            <img src="https://jzmall.lifejingzhi.com/file/jz-gw/tool-02.png" />
            <div class="tool-content">
              <div class="tool-title">德国卡赫商用多功能蒸洗清洁机</div>
              <div class="tool-line">· 140°高温、4Bar高压、85L/min蒸汽流</div>
              <div class="tool-line">· 蒸汽、汽液双重模式</div>
              <div class="tool-line">· 清除污渍去除异味</div>
              <div class="tool-line">· 亚特兰大悉尼奥运会清洁设备供应商</div>
            </div>
          </div>
          <div class="tool-item">
            <img src="https://jzmall.lifejingzhi.com/file/jz-gw/tool-03.png" />
            <div class="tool-content">
              <div class="tool-title">德国卡赫水过滤干湿吸尘器</div>
              <div class="tool-line">· 风动涡轮刷，有效吸除深处尘螨</div>
              <div class="tool-line">· 3层过滤系统，避免二次污染</div>
              <div class="tool-line">· 30ml阻泡剂，HEPA 13过滤器</div>
              <div class="tool-line">· 亚特兰大悉尼奥运会清洁设备供应商</div>
            </div>
          </div>
        </div>
        <div class="tips">* 以实际上户使用工具为准</div>
      </div>
      <!-- 服务人员 -->
      <div style="background:#fff">
        <div class="container">
          <div class="service-staff">
            <div class="staff-title">员工制服务人员</div>
            <div class="staff-guide">
              <div
                :class="['guide-item',activeStaff==item.id?'active-guide':'']"
                v-for="(item,index) in staffList"
                :key="index"
                @click="staffClick(item.id)"
              >{{item.title}}</div>
            </div>
            <div class="staff-list">
              <div
                :class="['staff-item',activeStaff==item.id?'active-staff':'']"
                v-for="(item,index) in staffList"
                :key="index"
              >
                <img :src="item.url" />
                <div class="staff-name">{{item.name}}</div>
                <div class="staff-content">{{item.content}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 鲸致荣誉 -->

      <div class="jz-honor">
        <div class="staff-title">鲸致荣誉</div>
         <!-- @scroll="honorScroll" -->

             <vue-seamless-scroll :data="honorList" class="honer-scroll"
        :class-option="seamlessScrollOption"

      >

            <div class="img-wrapper" >
            <img  :src="item"  v-for="(item,index) in honorList" :key="index"/>
           </div>



          </vue-seamless-scroll>
        <div class="progress-wrapper">
          <!-- <el-progress
            :text-inside="true"
            :stroke-width="3"
            :percentage="honerPer"
            :show-text="false"
            color="#00bdff"
          ></el-progress> -->
        </div>
      </div>
    </div>
    <el-dialog title :visible.sync="videoVisible" width="80%" :close-on-click-modal="false" center>
      <video
        width="100%"
        height="100%"
        controls
        poster="https://jzmall.lifejingzhi.com/file/jz-gw/jz-office.png"
      >
        <source
          src="https://media.lifejingzhi.com/sv/bd5ece2-18b37a9495b/bd5ece2-18b37a9495b.mp4"
          type="video/mp4"
        />您的浏览器不支持Video标签。
      </video>
    </el-dialog>
    <el-dialog
      title
      :visible.sync="detailVisible"
      width="900px"
      :close-on-click-modal="false"
      center
    >
      <div class="detail-img-block">
        <el-row v-if="activeDetail==0">
          <el-col :span="12">
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/bj/bj/bj2.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/bj/bj/bj3.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/bj/bj/bj4.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/bj/bj/bj5.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/bj/bj/bj6.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/bj/bj/bj7.jpg"
              alt
              class="img-responsive"
            />
          </el-col>
          <el-col :span="12">
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/bj/jx/jx2.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/bj/jx/jx3.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/bj/jx/jx4.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/bj/jx/jx5.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/bj/jx/jx6.jpg"
              alt
              class="img-responsive"
            />
          </el-col>
        </el-row>
        <el-row v-if="activeDetail==1">
          <el-col :span="12">
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/jiadian/kt/kt2.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/jiadian/kt/kt3.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/jiadian/kt/kt4.jpg"
              alt
              class="img-responsive"
            />
            <!-- <img src="./img/jiadian/youzao/youzao1.jpg" alt="" class="img-responsive"> -->
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/jiadian/youzao/youzao2.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/jiadian/youzao/youzao3.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/jiadian/youzao/youzao4.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/jiadian/youzao/youzao5.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/jiadian/youzao/youzao6.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/jiadian/youzao/youzao7.jpg"
              alt
              class="img-responsive"
            />
          </el-col>
          <el-col :span="12">
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/jiadian/zykt/zykt2.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/jiadian/zykt/zykt3.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/jiadian/zykt/zykt4.jpg"
              alt
              class="img-responsive"
            />
          </el-col>
        </el-row>
        <el-row v-if="activeDetail==2">
          <el-col :span="12">
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/shendu_chufang.jpg"
              alt
              class="img-responsive"
            />
          </el-col>
          <el-col :span="12">
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/shendu_yushi.jpg"
              alt
              class="img-responsive"
            />
          </el-col>
        </el-row>
        <el-row v-if="activeDetail==5">
          <el-col :span="12">
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/baomu.jpg"
              alt
              class="img-responsive"
            />
          </el-col>
          <el-col :span="12">
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/baomu/yuesao/yuesao2.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/baomu/yuesao/yuesao3.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/baomu/yuesao/yuesao4.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/baomu/yuesao/yuesao5.jpg"
              alt
              class="img-responsive"
            />
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <el-dialog
      title
      :visible.sync="detail2Visible"
      width="420px"
      :close-on-click-modal="false"
      center
    >
      <div class="detail-img-block">
        <el-row v-if="activeDetail==3">
          <el-col :span="24">
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/banjia/banjia2.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/banjia/banjia3.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/banjia/banjia4.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/banjia/banjia5.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/banjia/banjia6.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/banjia/banjia7.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/banjia/banjia8.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/banjia/banjia9.jpg"
              alt
              class="img-responsive"
            />
          </el-col>
        </el-row>
        <el-row v-if="activeDetail==4">
          <el-col :span="24">
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/baomu/zhongdiangong/zhongdiangong2.jpg"
              alt
              class="img-responsive"
            />
            <img
              src="https://jzmall.lifejingzhi.com/file/jz-gw/img/baomu/zhongdiangong/zhongdiangong3.jpg"
              alt
              class="img-responsive"
            />
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <jz-footer></jz-footer>

    <!-- 浮窗   v-draggable-->
    <div class="float-block"
>
      <img  src="https://jzmall.lifejingzhi.com/file/jz-gw/float-qw.png" class="float-qw"/>
     <div>关注公众号</div>
     <div>了解更多</div>
      <img  src="https://jzmall.lifejingzhi.com/file/jz-gw/float-gzh.png" class="float-gzh"/>
 <div>添加企业微信</div>
     <div>咨询更多</div>
    </div>

  </div>
</template>
<script>
import jzHeader from "@/components/common/Header";
import jzFooter from "@/components/common/Footer";
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
   directives: {
    draggable: {
      bind(el) {
        let dragging = false;
        let startX, startY, offsetX, offsetY, left, top;

        el.onmousedown = (e) => {
          dragging = true;
          startX = e.clientX;
          startY = e.clientY;
          offsetX = el.offsetLeft;
          offsetY = el.offsetTop;
          console.log( startX ,offsetX )
          console.log( startY  ,offsetY )

          el.style.position = 'fixed';
          el.setCapture && el.setCapture();
          el.onmousemove = mouseMove;
          el.onmouseup = mouseUp;
        };

        const mouseMove = (e) => {
          if (dragging) {
            left = e.clientX - startX + offsetX;
            top = e.clientY - startY + offsetY;

            el.style.left = left + 'px';
            el.style.top = top + 'px';
          }
        };

        const mouseUp = () => {
          dragging = false;
          el.onmousemove = null;
          el.onmouseup = null;
          el.releaseCapture && el.releaseCapture();
        };
      }
    }
  },
   computed: {
            duplicateImages() {
      // 复制图片以实现无限滚动
      return [...this.honorList, ...this.honorList];
    },

    seamlessScrollOption() {
      return {
        step: 1, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        isLoop: true, // 是否开启无缝滚动
      };
    },
   },

  data() {
    return {
      offset: 0, // 用于控制滚动位置
      intervalId: null, // 用于控制滚动的定时器
      honerPer: 40,
      activeDetail: 0,
      activeCategory: "",
      videoVisible: false,
      detailVisible: false,
      detail2Visible: false,
      categoryList: [
        {
          id: 1,
          cssId: "myModalA",
          title: "保洁服务",
          name: "档期在线预约",
          detail:
            "日常保洁、深度保洁、无家具粗开荒保洁、全屋焕新深度大扫除。定期保洁，舒适美好生活。",
          url: "https://jzmall.lifejingzhi.com/file/jz-gw/category-01.png"
        },
        {
          id: 2,
          cssId: "myModalB",
          title: "家电清洗",
          name: "专业设备清洗",
          detail:
            "针对家庭里经常使用的家用电器：空调、冰箱、洗衣机等，通过拆洗、冲洗、抑菌洗三个环节的服务，更好的呵护您与家人健康。",
          url: "https://jzmall.lifejingzhi.com/file/jz-gw/category-02-new.png"
        },
        {
          id: 3,
          cssId: "myModalC",
          title: "专区清洁",
          name: "深度除污除垢",
          detail:
            "围绕厨房、浴室、窗户、床品等提供专区深度清洁，有效减缓细菌滋生，为您提供健康干净的居住环境。",
          url: "https://jzmall.lifejingzhi.com/file/jz-gw/category-03-new.png"
        },
        {
          id: 4,
          cssId: "myModalD",
          title: "搬家收纳",
          name: "极致日式服务",
          detail:
            "包含全屋收纳、衣柜收纳、橱柜收纳等，家越住越大，享受整齐有序的生活环境，为生活营造秩序之美。",
          url: "https://jzmall.lifejingzhi.com/file/jz-gw/catrgory-04-new.png"
        },
        {
          id: 5,
          cssId: "myModalE",
          title: "家居养护",
          name: "全新家居清洁方案",
          detail:
            "包含地毯清洁、窗帘清洗、沙发清洗、木地板打蜡服务，专业设备深度清洁，让您的家焕然一新，温馨如初。",
          url: "https://jzmall.lifejingzhi.com/file/jz-gw/category-05-new.png"
        },
        {
          id: 6,
          cssId: "myModalF",
          title: "保姆/月嫂",
          name: "自培更专业",
          detail: "海量优质保姆资源，免面试快速匹配，不满意免费更换一次。",
          url: "https://jzmall.lifejingzhi.com/file/jz-gw/category-06.png"
        }
      ],
      activeStaff: 1,
      staffList: [
        {
          id: 1,
          title: "专业培训",
          url: "https://jzmall.lifejingzhi.com/file/jz-gw/service-02.png",
          name: "理论学习+实操检验",
          content: "线上线下统一培训"
        },
        {
          id: 2,
          title: "安全保障",
          url: "https://jzmall.lifejingzhi.com/file/jz-gw/service-03.png",
          name: "安全保障",
          content: "身份认证+健康认证+技能认证"
        },
        {
          id: 3,
          title: "服务上险",
          url: "https://jzmall.lifejingzhi.com/file/jz-gw/service-03-new.png",
          name: "商户订单",
          content: "均购买中国平安保险保障"
        }
      ],

      cardList: [
        {
          id: "01",
          title: "身份认证",
          name: "Identity authentication",
          content: "实名认证，身份溯源，彼此了解和交流，让您更安心",
          url: "https://jzmall.lifejingzhi.com/file/jz-gw/home/card-01-big.png",
          subUrl: "https://jzmall.lifejingzhi.com/file/jz-gw/home/card-01.png"
        },
        {
          id: "02",
          title: "专业培训",
          name: "Professional training",
          content: "专业培训，3天培训，1天考核，2天带教上户",
          url: "https://jzmall.lifejingzhi.com/file/jz-gw/home/card-02-big.png",
          subUrl: "https://jzmall.lifejingzhi.com/file/jz-gw/home/card-02.png"
        },
        {
          id: "03",
          title: "家政保险",
          name: "Housekeeping insurance",
          content: "提供人身保险及用户物品保障人身意外险，服务全程无忧",
          url: "https://jzmall.lifejingzhi.com/file/jz-gw/home/card-03-big.png",
          subUrl: "https://jzmall.lifejingzhi.com/file/jz-gw/home/card-03.png"
        },
        {
          id: "04",
          title: "装备规范",
          name: "Equipment specification",
          content: "专业工具套装，安全高效",
          url: "https://jzmall.lifejingzhi.com/file/jz-gw/home/card-04-big.png",
          subUrl: "https://jzmall.lifejingzhi.com/file/jz-gw/home/card-04.png"
        },
        {
          id: "05",
          title: "价格透明",
          name: "Price transparency",
          content: "收费规则简单、明码标价，公开透明、拒绝霸王条款",
          url: "https://jzmall.lifejingzhi.com/file/jz-gw/home/card-05-big.png",
          subUrl: "https://jzmall.lifejingzhi.com/file/jz-gw/home/card-05.png"
        },
        {
          id: "06",
          title: "评价反馈",
          name: "Evaluation feedback",
          content: "跟踪评价、及时反馈、定期回访、全程保障服务",
          url: "https://jzmall.lifejingzhi.com/file/jz-gw/home/card-06-big.png",
          subUrl: "https://jzmall.lifejingzhi.com/file/jz-gw/home/card-06.png"
        }
      ],
      activeCal: 0,
      honorList: [
        "https://jzmall.lifejingzhi.com/file/jz-gw/honor/1.png",
        "https://jzmall.lifejingzhi.com/file/jz-gw/honor/2.png",
        "https://jzmall.lifejingzhi.com/file/jz-gw/honor/3.png",
        "https://jzmall.lifejingzhi.com/file/jz-gw/honor/4.png",
        "https://jzmall.lifejingzhi.com/file/jz-gw/honor/5.png",
        "https://jzmall.lifejingzhi.com/file/jz-gw/honor/6.png",
        "https://jzmall.lifejingzhi.com/file/jz-gw/honor/7.png",
        "https://jzmall.lifejingzhi.com/file/jz-gw/honor/8.png",
        "https://jzmall.lifejingzhi.com/file/jz-gw/honor/9.png",
        "https://jzmall.lifejingzhi.com/file/jz-gw/honor/10.png",
        "https://jzmall.lifejingzhi.com/file/jz-gw/honor/11.png",
        "https://jzmall.lifejingzhi.com/file/jz-gw/honor/12.png",
        "https://jzmall.lifejingzhi.com/file/jz-gw/honor/13.png",
        "https://jzmall.lifejingzhi.com/file/jz-gw/honor/14.png",
        "https://jzmall.lifejingzhi.com/file/jz-gw/honor/15.png",
        "https://jzmall.lifejingzhi.com/file/jz-gw/honor/16.png",
        "https://jzmall.lifejingzhi.com/file/jz-gw/honor/17.png",
      ],
        dragging: false,
      offsetTop: 0,
      offsetLeft: 0,
      styleObject: {
        position: 'absolute',
        bottom: '30',
        right: '20'
      }
    };
  },
  components: {
    jzHeader,
    jzFooter,
    vueSeamlessScroll
  },
  mounted(){
    // this.startScroll();
  },
   beforeDestroy() {
  //  this.stopScroll();
  },
  methods: {
      startScroll() {
      this.intervalId = setInterval(() => {
        this.offset -= 1; // 每秒向左移动1像素
      }, 1000);
    },
    stopScroll() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    },
      dragStart(event) {
      this.dragging = true;
      const style = window.getComputedStyle(event.target, null);
      console.log(document.documentElement);
      this.offsetTop =document.documentElement.clientHeight-(Number(style.getPropertyValue('bottom').replace('px', '')) || 0);
      this.offsetLeft = document.documentElement.clientWidth-(Number(style.getPropertyValue('right').replace('px', '')) || 0);
      event.dataTransfer.setData('text/plain', null); // 设置drag event的data type
      console.log(this.offsetTop,this.offsetLeft);
    },
    dragEnd(event) {
      this.dragging = false;
    },
    moveElement(event) {
      if (this.dragging) {
        console.log('开始移动');
        console.log(event.clientY,this.offsetTop);
        console.log(event.clientX,this.offsetTop);
        this.styleObject.bottom = `${event.clientY - this.offsetTop}px`;
        this.styleObject.right = `${event.clientX - this.offsetLeft}px`;
      }
    },
    categoryHover(item) {
      this.activeCategory = item.id;
    },
    categoryOut(item) {
      this.activeCategory = "";
    },
    staffClick(id) {
      this.activeStaff = id;
    },
    playVideo() {
      this.videoVisible = true;
    },
    carouselChange(current, old) {
      this.activeCal = current;
      let index = current;
      let scrollElem = this.$refs.menu;
      if (index == 0 || index == 1) {
        // this.$refs.menu.scrollTop = '0';

        scrollElem.scrollTo({ top: 0, behavior: "smooth" });
      } else if (index == 2) {
        // this.$refs.menu.scrollTop = '105';
        scrollElem.scrollTo({ top: 105, behavior: "smooth" });
      } else if (index == 3) {
        // this.$refs.menu.scrollTop = '210';
        scrollElem.scrollTo({ top: 210, behavior: "smooth" });
      } else if (index == 4) {
        // this.$refs.menu.scrollTop = '315';
        scrollElem.scrollTo({ top: 315, behavior: "smooth" });
      }
    },
    navCarkClick(index) {
      this.activeCal = index;
      this.$refs.carousel.setActiveItem(index);
      let scrollElem = this.$refs.menu; // 对应ref的命名
      if (index == 0 || index == 1) {
        // this.$refs.menu.scrollTop = '0';

        scrollElem.scrollTo({ top: 0, behavior: "smooth" });
      } else if (index == 2) {
        // this.$refs.menu.scrollTop = '105';
        scrollElem.scrollTo({ top: 105, behavior: "smooth" });
      } else if (index == 3) {
        // this.$refs.menu.scrollTop = '210';
        scrollElem.scrollTo({ top: 210, behavior: "smooth" });
      } else if (index == 4) {
        // this.$refs.menu.scrollTop = '315';
        scrollElem.scrollTo({ top: 315, behavior: "smooth" });
      }
    },
    showDetail(index) {
      this.activeDetail = index;
      if (index == 3 || index == 4) {
        this.detail2Visible = true;
      } else {
        this.detailVisible = true;
      }
    },
    showServiceNew(index) {
      this.goService(index);
    },
    honorScroll() {
      const scrollLeft = document.getElementById("honor-list").scrollLeft;
      const clientWidth = document.getElementById("honor-list").clientWidth;
      const honorlist = document.getElementById("honor-list").scrollWidth;
      let scrollTotal = clientWidth + scrollLeft;
      let scrollPercent = Number(
        Number((scrollTotal / honorlist) * 100).toFixed(0)
      );
      //   console.log(scrollLeft,clientWidth,honorlist);
      //   console.log(scrollTotal,scrollPercent);
      this.honerPer = scrollPercent <= 40 ? 40 : Number(scrollPercent);
    },
    goService(index) {
      this.$router.push({
        path: "service",
        query: { id: index }
      });
    }
  }
};
</script>
<style  scoped>
.wrapper {
  background: #fff;
}
.home-page {
}
.top-banner {
  /* height: 550px;
  background: url("https://jzmall.lifejingzhi.com/file/jz-gw/home/home-banner.png")
    no-repeat center;
  background-size: 100% 100%; */
}
.top-banner img{
  width:980px;
}
.video-block {
  background: url("https://jzmall.lifejingzhi.com/file/jz-gw/jb-full.png") no-repeat
    center;
  background-size: 100%;
  height: 550px;
  padding: 88px 38px 40px;
}
.top-title {
  line-height: 30px;
  height: 30px;
  font-size: 30px;
  color: #fff;
}
.top-banner .sub-title {
  height: 16px;
  font-size: 16px;
  line-height: 16px;
  margin: 22px 0 32px 0;
  color: #fff;
}
.play-btn {
  width: 52px;
  height: 52px;
  cursor: pointer;
}
.jzsh {
  text-align: center;
  font-size: 26px;
  color: #fff;
  margin-top: 200px;
}
.zyjz {
  height: 308px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 0 40px;
}
.zyjz-left {
  height: 216px;
  font-size: 32px;
  /* font-weight: bold; */
}
.zyjz-left div {
  margin-bottom: 10px;
}
.zyjz-left img {
  width: 40px;
  height: 40px;
  object-fit: contain;
  margin-top: 56px;
}
.zyjz-right {
  display: flex;
}
.zyjz-item {
  flex: 1;
  width: 144px;
  height: 218px;
  background: url("https://jzmall.lifejingzhi.com/file/jz-gw/fw-01.png") no-repeat
    center;
  background-size: 100%;
  position: relative;
  margin-left: 30px;
  transition: all 0.4s;
}
.zyjz-item:nth-child(2) {
  background-image: url("https://jzmall.lifejingzhi.com/file/jz-gw/fw-02-new.png");
}
.zyjz-item:nth-child(3) {
  background-image: url("https://jzmall.lifejingzhi.com/file/jz-gw/fw-03-new.png");
}
.zyjz-item:nth-child(4) {
  background-image: url("https://jzmall.lifejingzhi.com/file/jz-gw/fw-04.png");
}
.item-title {
  position: absolute;
  top: 13px;
  left: -12px;
  width: 24px;
  height: 76px;
  background: #00bdff;
  text-align: center;
  color: #fff;
  writing-mode: vertical-rl;

  padding-right: 2px;
  letter-spacing: 2px;
}
.zyjz-item:hover {
  transform: scale(1.05);
  transition: all 0.4s;
  cursor: pointer;
}

.service-category {
  height: 880px;
  padding: 50px 40px;
}
.service-category > .title {
  font-size: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
}
.service-category .sub-title {
  font-size: 14px;
  height: 14px;
  line-height: 14px;
  margin: 18px 0 44px;
  text-align: center;
}
.category-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  font-size: 0;
}
.category-list .category-item {
  width: 286px;
  height: 330px;
  margin-bottom: 20px;
}

.category-item img {
  width: 286px;
  height: 182px;
}
.content-wrapper {
  height: 148px;
  padding: 20px 0 10px;
}
.content-wrapper .title {
  height: 14px;
  line-height: 14px;
  font-weight: 600;
  font-size: 14px;
}
.content-wrapper .name {
  color: #666666;
  font-size: 14px;
  height: 14px;
  line-height: 14px;
  margin: 8px 0 10px;
}
.content-wrapper .detail {
  color: #999999;
  font-size: 10px;
  line-height: 16px;
  margin-bottom: 14px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  overflow: hidden;
  min-height: 32px;
}
.category-item:hover {
  cursor: pointer;
}
.category-item:hover .content-wrapper {
  padding: 20px 12px 10px 20px;
  background: #00bdff;
  color: #fff !important;
  transition: background 0.3s;
}
.category-item:hover .content-wrapper .name {
  color: #fff;
}
.category-item:hover .content-wrapper .detail {
  color: #fff;
}
.content-wrapper .detail-btn {
  width: 76px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  color: #999;
  font-size: 10px;
  border: 1px solid #eeeeee;
  background: #f9fbfd;
  border-radius: 24px;
}
.content-wrapper img {
  width: 76px;
  height: 24px;
}
/* 鲸致优势 */
/* 服务流程 */
.service-flow {
  height: 610px;
  background: url("https://jzmall.lifejingzhi.com/file/jz-gw/fwlc-bg.png") no-repeat
    center top;
  background-size: contain;
  padding: 50px 30px 0;
  position: relative;
}
.service-flow .title {
  font-size: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
}
.service-flow .sub-title {
  font-size: 14px;
  height: 14px;
  line-height: 14px;
  margin: 18px 0 308px;
  text-align: center;
}
.service-flow img {
  width: 286px;
  height: 470px;
  position: absolute;
  top: 140px;
  left: 347px;
}
.flow-block {
  display: flex;
  justify-content: space-between;
  height: 120px;
}
.flow-left {
  width: 360px;
  background: #64d7ff;
  border-radius: 0 0 0 30px;
  display: flex;
  box-shadow: 0 4px 10px #eee;
}
.flow-right {
  width: 360px;
  background: #64d7ff;
  border-radius: 0 0 30px 0;
  display: flex;
  box-shadow: 0 4px 10px #eee;
}
.flow-left > div,
.flow-right > div {
  flex: 1;
  height: 120px;
  color: #fff;
  text-align: center;
  font-size: 14px;
  padding-top: 70px;
  line-height: 14px;
}
.step-two {
  background: #00bdff;
  border-radius: 0 0 0 30px;
}
.step-three {
  background: #00bdff;
  border-radius: 0 0 30px 0;
}
/* 进口工具 */
.tool-group {
  height: 570px;
  padding: 50px 38px 0;
}
.tool-group-title {
  font-size: 32px;
  line-height: 32px;
  height: 32px;
  text-align: center;
}
.tool-list {
  display: flex;
  height: 374px;
  justify-content: space-between;
  margin: 28px 0 14px;
}
.tool-item {
  width: 286px;
  font-size: 0;
}
.tool-item img {
  width: 286px;
  height: 196px;
  object-fit: contain;
}
.tool-content {
  height: 178px;
  background-image: linear-gradient(-55deg, #64d7ff 0%, #00bcff 100%);
}
.tool-content .tool-title {
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 4px;

  padding-left: 16px;
  background: url("https://jzmall.lifejingzhi.com/file/jz-gw/devide-line.png")
    no-repeat center bottom;
  background-size: 96%;
}
.tool-content .tool-line {
  padding-left: 16px;
  font-size: 12px;
  line-height: 26px;
  color: #fff;
}
.tool-group .tips {
  font-size: 14px;
  line-height: 14px;
  text-align: right;
}
/* 服务人员 */
.service-staff {
  height: 532px;
  padding: 50px 38px 0;
}
.staff-title {
  font-size: 32px;
  line-height: 32px;
  height: 32px;
  text-align: center;
}
.staff-guide {
  margin: 28px auto 30px;
  width: 330px;
  display: flex;
  height: 36px;
  line-height: 36px;
  border: 1px solid #1ebdf5;
  border-radius: 36px;
  overflow: hidden;
  cursor: pointer;
}
.guide-item {
  width: 110px;
  text-align: center;
  color: #1ebdf5;
  font-size: 14px;
  text-align: center;
}
.guide-item:nth-child(2) {
  border-left: 1px solid #1ebdf5;
  border-right: 1px solid #1ebdf5;
}
.guide-item:hover {
  /* background: linear-gradient(90deg, #64d7ff 0%, #1ebdf5 100%);
  color: #fff; */
}
.guide-item.active-guide {
  background: linear-gradient(90deg, #64d7ff 0%, #1ebdf5 100%);
  color: #fff;
}
.staff-list {
  display: flex;
  justify-content: space-between;
}
.staff-item {
  width: 286px;
  height: 280px;
  background: #f4f6f9;
  border-radius: 10px;
  overflow: hidden;
  font-size: 0;
}
.staff-item:hover {
  /* box-shadow: 0 0 12px 2px #bee3f0; */
}
.staff-item.active-staff {
  box-shadow: 0 0 12px 2px #bee3f0;
}
.staff-item img {
  width: 286px;
  height: 196px;
}
.staff-name {
  text-align: center;
  font-size: 14px;
  line-height: 18px;
  height: 14px;
  margin: 17px 0 6px;
}
.staff-content {
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  height: 20px;
}
.common-title {
  font-size: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
}
.jz-advantage {
  height: 496px;
  padding: 50px 40px;
}
.advantage-wrapper {
  display: flex;
  margin-top: 30px;
}
.advantage-left {
  width: 280px;
  margin-right: 20px;
}
.advantage-right {
  flex: 1;
  background: url("https://jzmall.lifejingzhi.com/file/jz-gw/mag-bg.png") no-repeat
    center;
  background-size: 100%;
  height: 315px;
}
.advantage-item {
  text-align: center;
}
.advantage-item img {
  width: 240px;
  height: 240px;
}
.card-content {
  width: 480px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  margin-top: -100px;
  border: 1px solid #eee;
  box-shadow: 0 0 12px 2px #eee;
  background: #fff;
  margin-left: 80px;
  position: relative;
  z-index: 999;
}
 .el-carousel__indicator.is-active button {
  background: #00bcff;
}
.advantage-left {
  width: 282px;
  height: 315px;
  overflow-y: hidden;
  box-shadow: 0 0 12px 2px #eee;
  transition: all 0.3s;
}
::-webkit-scrollbar {
  display: none;
}
.nav-item {
  width: 282px;
  height: 105px;
  display: flex;
  align-items: center;
  padding: 0 20px 0 28px;
  justify-content: space-between;
  cursor: pointer;
}
.nav-item:hover {
  background: rgb(244, 246, 249);
}
.nav-item:hover .card-number {
  font-size: 85px;
}
.nav-item:hover .card-title {
  color: #00bdff;
}
.nav-item.active-card {
  background: #00bdff;
}
.card-title {
  height: 14px;
  line-height: 14px;
  margin-bottom: 12px;
}
.card-name {
  font-size: 8px;
  color: #666;
  white-space: nowrap;
}
.card-number {
  opacity: 0.5;
  font-size: 48px;
  color: #ddd;
}
.active-card .card-name {
  color: #fff;
}
.active-card .card-title {
  color: #fff;
}
.active-card.nav-item:hover .card-title {
  color: #fff;
}
.active-card .card-number {
  color: #fff;
  font-size: 85px;
}
.detail-img-block img {
  width: 100%;
}
.el-carousel__item--card,
.el-carousel__item.is-animating {
  transition: transform 0.12s ease-in-out, -webkit-transform 0.12s ease-in-out;
}
.jz-honor {
  margin: 30px auto 20px;
  text-align: center;
  width: 90%;
  min-width: 980px;
  max-width: 1540px;


 overflow: hidden;

   position: relative;

}
.honer-scroll{
 height: 160px;
  margin-top: 20px;
  /* width:1200px; */
    width: 100%;
     min-width: 1100px;
  max-width: 1540px;
  overflow: hidden;
  white-space: nowrap;
}
.honer-scroll>div{
  overflow: visible!important;
}
.honer-scroll .img-wrapper{
  width:auto;
 min-width:1100px;
   /* height:auto;
   white-space: nowrap; */
  /* width:100%;
 min-width: 980px;
  max-width: 1540px; */
}

.honer-scroll ul{
  width:100%;
     min-width: 980px;
  max-width: 1540px;
}
.honor-wrapper {

  margin-top: 20px;
  height: 160px;
  width: 100%;
    min-width: 980px;
  max-width: 1540px;
  display: flex;

  /* white-space: nowrap; */
  /* overflow-y: hidden; */

 /* animation: scroll 20s linear infinite;  */
}
.scroll-item{
  display: inline-block;
}
/* .honor-wrapper::-webkit-scrollbar {
  display: none;
} */
.img-wrapper{
  display: inline-block;
  height:160px;
}
.honer-scroll img {
  height: 160px;
  margin-right: 20px;
}
@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-300%); /* 根据实际图片总宽度调整 */
  }
}
.progress-wrapper {
  width: 60px;
  margin: 40px auto 44px;
}
.float-block{
  position:fixed;
  right:20px;
  bottom:40px;
  width:127px;
  height:289px;
  background: url("https://jzmall.lifejingzhi.com/file/jz-gw/float-bg.png") no-repeat
    center;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding:26px  0;
  z-index:9999;
   /* cursor: move; */
  user-select: none;
}
.float-block img{
  width:72px;
  height:72px;

}
.float-block div{
  font-size: 12px;
  height:14px;
  line-height: 14px;
  color: #fff;
}
.float-qw{
  margin:0 0 9px;
}
.float-gzh{
  margin:15px 0 9px;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue